import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

const AdSpace = ({ type, ad, className = "" }) => {
  const { t } = useLanguage();
  
  // Helper to ensure the URL never breaks for local images
  const getCleanUrl = (url) => {
    if (!url) return '';
    if (url.includes('http')) return url; // Cloudinary or External support
    const backend = process.env.REACT_APP_BACKEND_URL || '';
    const cleanBackend = backend.endsWith('/') ? backend.slice(0, -1) : backend;
    const cleanUrl = url.startsWith('/') ? url : `/${url}`;
    return `${cleanBackend}${cleanUrl}`;
  };

  // Removed fixed heights so the parent container (Home.jsx) defines the shape
  const baseClasses = "w-full h-full flex items-center justify-center overflow-hidden transition-all";

  const handleAdClick = () => {
    if (ad?.link) {
      window.open(ad.link, '_blank', 'noopener,noreferrer');
    }
  };

  // 1. Placeholder when no ad is uploaded for this slot
  if (!ad) {
    return (
      <div
        className={`${baseClasses} bg-gray-50 border border-dashed border-gray-200 text-gray-300 text-[10px] font-black uppercase tracking-widest p-4 text-center ${className}`}
        data-testid={`ad-space-${type}`}
      >
        ಜಾಹೀರಾತು <br /> {type.replace('_', ' ')}
      </div>
    );
  }

  // 2. CASE: Google AdSense or Custom HTML Script
  if (ad.script) {
    return (
      <div 
        className={`${baseClasses} ${className}`}
        dangerouslySetInnerHTML={{ __html: ad.script }}
        data-testid={`ad-script-${type}`}
      />
    );
  }

  // 3. CASE: Local Image Advertisement (Clickable)
  return (
    <div
      className={`${baseClasses} ${ad.link ? 'cursor-pointer hover:opacity-90 group' : ''} ${className}`}
      onClick={handleAdClick}
      data-testid={`ad-image-${type}`}
    >
      <img
        src={getCleanUrl(ad.imageUrl)}
        alt="Kallina Koogu Advertisement"
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        onError={(e) => {
          e.target.src = 'https://via.placeholder.com/400x400?text=Ad+Image+Missing';
        }}
      />
    </div>
  );
};

export default AdSpace;
